import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../store";
import { Market } from "../../models/Market";
import { formatCurrency } from "../../utils";
import { Language } from "../../models/Translation";
import { asList, useLoadIfEmpty } from "../../hooks/useLoadIfEmpty";
import { thunkFetchCurrentMarket } from "../../store/markets/actions";
import { thunkFetchLanguages } from "../../store/languages/actions";

interface CurrencyProps {
  value: number;
  priceUnit?: string;
  noDecimals?: boolean;

  currency?: string;
  children?: React.ReactNode;
}

export const Currency: FunctionComponent<CurrencyProps> = ({
  value,
  priceUnit,
  noDecimals,
  currency,
  children
}) => {
  const market =
    useSelector<AppState, Market>(s => s.currentMarket) || ({} as Market);
  const languages = asList<Language>(
    useSelector<AppState, unknown>(s => s.languages)
  );

  useLoadIfEmpty(!market?.currency && !market?.id, thunkFetchCurrentMarket);
  useLoadIfEmpty(!languages.length, thunkFetchLanguages);
  const currencyFormatLanguage = languages?.find(
    l => l.id === market.currencyLanguageId
  );

  const locale = `${currencyFormatLanguage?.code ?? "sv"}-${
    market.countryCode || "SE"
  }`;

  return (
    <>
      {formatCurrency(
        value,
        currency !== undefined ? currency : market.currency,
        locale
      )}
      {priceUnit ? `/${priceUnit}` : ""} {children}
    </>
  );
};
